import { render, staticRenderFns } from "./BaseTLInfoPanel.vue?vue&type=template&id=4f08522b&"
import script from "./BaseTLInfoPanel.vue?vue&type=script&lang=ts&"
export * from "./BaseTLInfoPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports